import {axiosInstances} from "../axios-instances";
import Cookies from "js-cookie";
import qs from 'qs';

export const getDangerProducts = async (params) => {
  const { data } = await axiosInstances.get('/amantrans/danger-items/get-all', {
    headers: {
      Authorization: `Bearer ${Cookies.get('token')}`,
    },
    params, 
  });

  return data;
};

export const deleteDangerProducts = async (params) => {
  try {
    const response = await axiosInstances.delete(
      `/amantrans/danger-items/delete`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
        params: params
      }
    );
    return response.data;

  } catch (error) {
      console.error("Error deleting status:", error);
      throw error; 
  }
};

export const createDangerProducts = async (params) => {
  const response = await axiosInstances.post(
    `/amantrans/danger-items/create`,
    qs.stringify(params),
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        }
    }
  );

  return response.data;
}

export const editDangerProducts = async (id, name) => {
  const response = await axiosInstances.put(
    `/amantrans/danger-items/update`,
    null, 
    {
      params: {
        id,
        name
      },
      headers: {
        Authorization: `Bearer ${Cookies.get('token')}`,
      },
    }
  );

  return response.data;
};